export const getScrollTargetSpecificRoom = (roomId: string) =>
  `scrollToTarget-roomCard-${roomId}`
